import './App.css'
import { RouterProvider } from 'react-router-dom'
import { createRouter } from './routes'
import Helmet from 'react-helmet'
import Suspense from './Suspense'
import * as Sentry from '@sentry/react'

import { ToastContainer } from 'react-toastify'
import { useEffect } from 'react'
import ModuleContext from './context/ModuleContext'

function App() {
  useEffect(() => {
    const isProd = ['invision360.com'].some((u) => process.env.REACT_APP_API_URL.includes(u))

    Sentry.init({
      org: 'invision360',
      project: '360',
      dsn: process.env.REACT_APP_SENTRY_DSN,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      disableLogger: isProd,

      integrations: [
        Sentry.captureConsoleIntegration({
          levels: ['error']
        })
      ]
    })
  }, [])

  if (!process.env.REACT_APP_MODULE_ID) {
    console.warn('NO MODULE ID IN .env!')
  }

  const title = () => {
    const moduleId = process.env.REACT_APP_MODULE_ID

    switch (moduleId) {
      // QEPA
      case 'e37d182b-a8e2-4342-8d93-3416b2ee6a1c':
        return 'Invision360 Educational Psychology advice QA Module'
      // AR
      case 'f17a1b26-61c5-11ed-9e9a-06fae64f1ba6':
        return 'Invision360 Annual Review QA Module'
      // EHCP
      case 'a23a24a6-c29d-4e3e-96d7-342a73c5c533':
        return 'Invision360 EHCP QA Module'
      default:
        return 'Invision360'
    }
  }

  const router = createRouter()

  return (
    <>
      <Helmet defaultTitle={title()} titleTemplate={`%s | ${title()}`} defer={false} />

      <Suspense>
        <ModuleContext.Provider>
          <RouterProvider router={router} />
        </ModuleContext.Provider>
      </Suspense>
      <ToastContainer autoClose={3000} />
    </>
  )
}

export default App
